import { AnalyticsEvent } from "@common/constants/analytics-events";
import { StepConfig } from "./types";

const productPreviewSidebarKey = "productPreview";
const organizationPreviewSidebarKey = "organizationPreview";

export type OnboardingStepKey =
    | "start"
    | "verify"
    | "purpose"
    | "profile"
    | "firmInfo"
    | "firmSetup"
    | "introCall"
    | "waitlistOutro"
    | "accountantWaitlistIntro"
    | "accountantWaitlistOutro"
    | "outro"
    | "accountantOutro"
    | "connectAccounts"
    | "paymentProcessor"
    | "payroll"
    | "choosePlan"
    | "inviteProfile"
    | "mobileBlock"
    | "organizationProfile"
    | "createOrganization"
    | "organizationClientProfile"
    | "subscribe"
    | "enterpriseCall"
    | "accountantPartnerCall"
    | "accountantPartnerCallOutro"
    | "matchWithAccountant";

export const onboardingStepsConfigs: Record<OnboardingStepKey, StepConfig> = {
    start: {
        cover: "full",
    },
    verify: {
        cover: "full",
    },
    purpose: {
        cover: "full",
    },
    profile: {
        cover: "split",
        sidebar: productPreviewSidebarKey,
    },
    firmInfo: {
        cover: "split",
        sidebar: organizationPreviewSidebarKey,
    },
    firmSetup: {
        cover: "split",
        sidebar: organizationPreviewSidebarKey,
    },
    introCall: {
        cover: "full",
    },
    waitlistOutro: {
        cover: "split",
        sidebar: productPreviewSidebarKey,
    },
    accountantWaitlistIntro: {
        cover: "split",
        sidebar: productPreviewSidebarKey,
    },
    accountantWaitlistOutro: {
        cover: "split",
        sidebar: productPreviewSidebarKey,
    },
    outro: {
        cover: "full",
    },
    accountantOutro: {
        cover: "full",
    },
    connectAccounts: {
        cover: "sidebar",
    },
    paymentProcessor: {
        cover: "sidebar",
    },
    payroll: {
        cover: "sidebar",
    },
    choosePlan: {
        cover: "full",
    },
    inviteProfile: {
        cover: "split",
    },
    mobileBlock: {
        cover: "full",
    },
    organizationProfile: {
        cover: "split",
        sidebar: organizationPreviewSidebarKey,
    },
    createOrganization: {
        cover: "split",
        sidebar: organizationPreviewSidebarKey,
    },
    organizationClientProfile: {
        cover: "split",
        sidebar: organizationPreviewSidebarKey,
    },
    subscribe: {
        cover: "full",
    },
    enterpriseCall: {
        cover: "full",
    },
    accountantPartnerCall: {
        cover: "full",
    },
    accountantPartnerCallOutro: {
        cover: "split",
        sidebar: organizationPreviewSidebarKey,
    },
    matchWithAccountant: {
        cover: "split",
        sidebar: productPreviewSidebarKey,
    },
};

export const OnboardingStepAnalyticsEventMapping: Record<
    OnboardingStepKey,
    AnalyticsEvent
> = {
    start: AnalyticsEvent.ONBOARDING_START,
    verify: AnalyticsEvent.ONBOARDING_VERIFY,
    purpose: AnalyticsEvent.ONBOARDING_PURPOSE,
    profile: AnalyticsEvent.ONBOARDING_PROFILE,
    firmInfo: AnalyticsEvent.ONBOARDING_FIRM_INFO,
    firmSetup: AnalyticsEvent.ONBOARDING_FIRM_SETUP,
    introCall: AnalyticsEvent.ONBOARDING_INTRO_CALL,
    waitlistOutro: AnalyticsEvent.ONBOARDING_WAITLIST_OUTRO,
    accountantWaitlistIntro:
        AnalyticsEvent.ONBOARDING_ACCOUNTANT_WAITLIST_INTRO,
    accountantWaitlistOutro:
        AnalyticsEvent.ONBOARDING_ACCOUNTANT_WAITLIST_OUTRO,
    outro: AnalyticsEvent.ONBOARDING_OUTRO,
    accountantOutro: AnalyticsEvent.ONBOARDING_ACCOUNTANT_OUTRO,
    connectAccounts: AnalyticsEvent.ONBOARDING_CONNECT_ACCOUNTS,
    paymentProcessor: AnalyticsEvent.ONBOARDING_PAYMENT_PROCESSOR,
    payroll: AnalyticsEvent.ONBOARDING_PAYROLL,
    choosePlan: AnalyticsEvent.ONBOARDING_CHOOSE_PLAN,
    inviteProfile: AnalyticsEvent.ONBOARDING_INVITE_PROFILE,
    mobileBlock: AnalyticsEvent.ONBOARDING_MOBILE_BLOCK,
    organizationProfile: AnalyticsEvent.ONBOARDING_ORGANIZATION_PROFILE,
    createOrganization: AnalyticsEvent.ONBOARDING_CREATE_ORGANIZATION,
    organizationClientProfile:
        AnalyticsEvent.ONBOARDING_ORGANIZATION_CLIENT_PROFILE,
    subscribe: AnalyticsEvent.ONBOARDING_SUBSCRIBE,
    enterpriseCall: AnalyticsEvent.ONBOARDING_ENTERPRISE_CALL,
    accountantPartnerCall: AnalyticsEvent.ONBOARDING_ACCOUNTANT_PARTNER_CALL,
    accountantPartnerCallOutro:
        AnalyticsEvent.ONBOARDING_ACCOUNTANT_PARTNER_CALL_OUTRO,
    matchWithAccountant: AnalyticsEvent.ONBOARDING_MATCH_WITH_ACCOUNTANT,
};
